import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Sucursal } from '../modelos/sucursal';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SucursalService {
  // private urlApi : string = 'http://localhost:8080/api/sucursales';
  private urlApi: string = environment.urlAdmin + '/sucursales';
  // private urlApi : string = 'http://200.39.22.86:6061/buro/api/sucursales';

  // private urlApi : string = 'http://192.168.1.13:8080/buro/api/sucursales';

  #sucursalesSubject = new BehaviorSubject<Sucursal[]>([]);

  constructor(private http: HttpClient) {
    this.http
      .get<Sucursal[]>(this.urlApi)
      .pipe(map((sucursales) => sucursales.sort(this.SortArray)))
      .subscribe((sucursales) => {
        this.#sucursalesSubject.next(sucursales);
      });
  }

  SortArray(x: Sucursal, y: Sucursal) {
    return x.nombreSucursal.localeCompare(y.nombreSucursal, 'fr', {
      ignorePunctuation: true,
    });
  }

  getSucursales(): Observable<Sucursal[]> {
    return this.#sucursalesSubject.asObservable();
  }

  getAnSucursal(id: number): Observable<Sucursal> {
    const value = this.#sucursalesSubject.value.find(
      (sucursal) => sucursal.idSucursal === id
    );
    return value ? of(value) : this.http.get<Sucursal>(`${this.urlApi}/${id}`);
  }
}
